import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import * as React from 'react';
import { FlexBox } from '../box';
import { Divider } from '../divider';
import { IconArrowDropDown, IconLanguage } from '../icon';
import { Typography } from '../typography';
export const LanguagePickerSelectedMenuItem = observer((props) => {
    const { option, localeOptionsCount, isDisabled, isOpen } = props;
    const color = isDisabled
        ? 'action.disabled'
        : 'components.language-picker.contrast.icon';
    return (_jsxs(FlexBox, { gap: 1, vAlign: "center", height: "100%", children: [_jsx(IconLanguage, { color: color, filled: isOpen, fontSize: "small" }), _jsx(Typography, { textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: 180, children: option.label }), _jsx(Divider, { orientation: "vertical" }), localeOptionsCount && (_jsx(Typography, { children: localeOptionsCount })), _jsx(IconArrowDropDown, { color: color, filled: isOpen })] }));
});
